<template>
    <div>
      <app-header class="haeder-r"></app-header>
        <!--slider end -->

        <div class="box-title">
            <h2>Our projects</h2>
        </div>
        <section class="full-page gallery" >
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12 col-xs-12 col-sm-12 ">
                        <div class="box-title">
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A alias asperiores aspernatur assumenda
                                at aut consectetur
                            </p>
                        </div>
                    </div>
                    <div class="container">
                        <div class="row">
                            <div class="box-filter">
                                <ul class="text-center ">
                                    <a class="button is-checked" @click="toggle('all')">الكل</a>
                                </li>
                                    <li  v-for="category in categories"><a @click="toggle(category.name)">{{category.name}}</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <ul class="ul-gallery">
                        <li v-for="project in projects" class="col-xs-12 col-sm-6 col-lg-3 col-md-4">
                         <div class="box-li">
                            <a :href="/project/+project.slug">
                                <div class="box-img" :style="'background-image: url('+ project.image +')'"></div>
                                <div class="box-text">
                                <h3>{{project.title}}</h3>
                                </div>
                            </a>
                         </div>
                        </li>
                    </ul>

                </div>
            </div>
        </section>
      <app-footer></app-footer>
    </div>
</template>
<script>
import {Urls,checkForDub} from '../config'
  export default {
    mounted(){
        //  $(".lightgallery").lightGallery()
        this.getProjects()
            $('.carousel').carousel();

    },
    data(){
      return {
        loading : false,
        cat : [],
        type : 'all'
      }
    },
    methods: {
        openGallery(images){
            var $lg = $('#dynamic');
            let gal = images
            gal.forEach(image => {
                image.src = image.img
            })
                var lg = $lg.lightGallery({
                    dynamic: true,
                    dynamicEl: gal,
                });
                lg.one("onCloseAfter.lg", function() {
                    lg.data('lightGallery').destroy(true);
                });
        },
        getProjects(){
          this.loading = true
          this.axios.get(Urls.projectsUrl+'?pages=16')
              .then((response) => {
              // Success
              this.loading = false
              if(response.status === 200){
                  this.pagination = response.data.meta
                  response.data.data.forEach(project => {
                  if(! checkForDub(this.projects,project,'slug')){
                      this.$store.commit('projects/add', project)
                  }
                  })
              }
              }).catch((errors) => {
              // error
              this.loading = false
              console.log(errors)
              this.err = errors
          })
      },
      toggle(selected){
            if(selected == 'all'){
                this.type = 'all'
            }
            if(selected === 'hide'){
                this.type = false
            }
            this.type = selected
      },
      selected(project){
            if(this.type === 'all'){
                return true
            }
            for(var i = 0; i < project.category.length; i++) {
                if(project.category[i].name === this.type) {
                    return true;
                }
            }
            return false;
      },
    },
    computed:{
        projects(){
            return this.$store.state.projects.projects
        },
        categories(){
            this.projects.forEach(project => {
                   project.category.forEach(category => {
                        if(! checkForDub(this.cat,category,'id')){
                            this.cat.push(category)
                        }
                    })
            })
            return this.cat
        }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/projects.vue